import { formatAmountAsPerTheCoinUnit } from "src/utils/formatAmountAsPerTheCoinUnit";
import { getSubAccountFinancialsReport } from "./API";
import { HASHRATE, convertTo, formatHashrateToUnit } from "src/api/HashrateFormatter";
import { applySorting, getComparator } from "src/utils/filterAndSortData";
import dayjs from "dayjs";

const formatHashrate = hashrate => {
    // Server returns raw Sol/s values - format to appropriate unit
    return formatHashrateToUnit(hashrate);
};

const GetSubAccountFinancialsReport = async (
    startDate,
    endDate,
    subAccounts,
    timeInterval,
    accessToken
) => {
    try {
        const { data } = await getSubAccountFinancialsReport(
            startDate,
            endDate,
            subAccounts,
            timeInterval,
            accessToken
        );
        const financialReportData = data.subAccountStats.flatMap(acct => {
            return applySorting(
                acct.subAccountStats.map(stat => {
                    return {
                        ...stat,
                        startDate: dayjs(stat.startDate)
                            .utcOffset(stat.startDate.slice(-6))
                            .format("YYYY-MM-DD HH:mm:ss"),
                        endDate: dayjs(stat.endDate)
                            .utcOffset(stat.endDate.slice(-6))
                            .format("YYYY-MM-DD HH:mm:ss"),
                        earningsCreditTime:
                            timeInterval === "byDay"
                                ? dayjs(stat.earningsCreditTime)
                                      .utcOffset(stat.earningsCreditTime.slice(-6))
                                      .format("YYYY-MM-DD HH:mm:ss")
                                : null,
                        hashrate: formatHashrate(stat.hashrateAccepted),
                        // Server returns raw Sol/s values - convert to TSol/s for export
                        convertedHashrate: convertTo(
                            stat.hashrateAccepted,
                            HASHRATE.SOLS,
                            HASHRATE.TSOLS
                        ),
                        groupName: acct.groupName,
                        subAccountName: acct.subAccountName,
                        feeRatePercent: stat.feeRatePercent,
                        poolFeeAmount: formatAmountAsPerTheCoinUnit("ZEC", stat.poolFeeAmount),
                        ppsBaseAmount: formatAmountAsPerTheCoinUnit("ZEC", stat.ppsBaseAmount),
                        txFeeRewardAmount: formatAmountAsPerTheCoinUnit(
                            "ZEC",
                            stat.txFeeRewardAmount
                        ),
                        earned: formatAmountAsPerTheCoinUnit("ZEC", stat.earned),
                        withdrawn: formatAmountAsPerTheCoinUnit("ZEC", stat.withdrawn),
                        grossEarnings: formatAmountAsPerTheCoinUnit("ZEC", stat.grossEarnings),
                        balance: formatAmountAsPerTheCoinUnit("ZEC", stat.balance),
                    };
                }),
                getComparator("desc", "startDate")
            );
        });
        const totals = applySorting(
            data.totalSubAccountStats.map(stat => {
                return {
                    ...stat,
                    startDate: dayjs(stat.startDate)
                        .utcOffset(stat.startDate.slice(-6))
                        .format("YYYY-MM-DD HH:mm:ss"),
                    // Server returns raw Sol/s values - convert to TSol/s for export
                    hashrate: convertTo(stat.hashrateAccepted, HASHRATE.SOLS, HASHRATE.TSOLS),
                    ppsBaseAmount: formatAmountAsPerTheCoinUnit("ZEC", stat.ppsBaseAmount),
                    txFeeRewardAmount: formatAmountAsPerTheCoinUnit("ZEC", stat.txFeeRewardAmount),
                    earned: formatAmountAsPerTheCoinUnit("ZEC", stat.earned),
                    withdrawn: formatAmountAsPerTheCoinUnit("ZEC", stat.withdrawn),
                    poolFeeAmount: formatAmountAsPerTheCoinUnit("ZEC", stat.poolFeeAmount),
                    grossEarnings: formatAmountAsPerTheCoinUnit("ZEC", stat.grossEarnings),
                    balance: formatAmountAsPerTheCoinUnit("ZEC", stat.balance),
                };
            }),
            getComparator("desc", "startDate")
        );
        return { success: true, data: financialReportData, totals };
    } catch (error) {
        return {
            success: false,
            data: error?.response?.data?.message
                ? error?.response?.data?.message
                : "Error: Error getting report data.",
        };
    }
};

export default GetSubAccountFinancialsReport;
